import state from './moduleDraftState.js'
import mutations from './moduleDraftMutations.js'
import actions from './moduleDraftActions.js'
import getters from './moduleDraftGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
